import "./progress-bar.scss";

import { useEffect, useState } from "react";

import { useFormFlowContext } from "../forms/FormFlowContext";

export default function ProgressBar() {
  const { currentPage, totalPages } = useFormFlowContext();
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const percent = (currentPage / totalPages) * 100;
    setProgress(percent);
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [currentPage, totalPages]);

  return (
    <div className="progress-bar mb-base">
      <span style={{ width: `${progress}%` }}></span>
      <span style={{ width: `${100 - progress}%` }}></span>
    </div>
  );
}
